import React, { useEffect, useState } from 'react'
import { OBJECT_NET } from '../../../../store/Settings/sets'
import { cl } from '../../../../utilities/cl'
import { prepareSettings } from '../../utilities/prepareSettings'
import { carryUpdate } from '../../utilities/carryUpdate'
import { updateHelper } from '../../utilities/updateHelper'
import { setsex, setsmob } from '../../utilities/setsclasses'
import fields from './fields'
import Builder from '../../Builder'
import fieldPppoename from './items/pppoename'
import fieldPppoepass from './items/pppoepass'
import fieldLip from './items/lip'
import fieldGateway from './items/gateway'
import fieldDns from './items/dns'
import fieldLinterval from './items/linterval'
import ItemSave from './items/save'
import CheckBox from '../../../CheckBox'
import Switch from '../../../Form/Switch'
import { useDispatch } from 'react-redux'

import { updateOptions as settings_updateOptions } from '../../../../store/Settings/actions'
import { putChanged } from '../../../../store/Settings/actions/Changed'


const SettingsObjectNet = ({
    className = "",
    settings = {},
    stateKey,
    loadSettings,
    updateOptions,
    saveSettings: saveSettingsInner,
    loading,
}) => {



    const dispatch = useDispatch()
    className = cl(className, "SettingsObjectNet")

    // Инициализация состояйний с учетом текущих settings
    const [usePppoe, setUsePppoe] = useState(false)
    const [useDhcp, setUseDhcp] = useState(true)

    useEffect(() => {
        // Обновляем состояния при получении settings
        setUsePppoe(!!settings.pppoename)
        setUseDhcp(!settings.lip)
    }, [settings.pppoename, settings.lip])

    useEffect(() => {
        if (!loading)
            loadSettings({
                type: OBJECT_NET,
                stateKey,
                fields,
            })
    }, [stateKey, loading])

    // Остальной код остается без изменений
    let validMap
    [settings, validMap] = prepareSettings({
        type: OBJECT_NET,
        settings: settings,
    })


    updateOptions = carryUpdate({
        type: OBJECT_NET,
        stateKey,
        updateOptions
    })

    const hChange = (name, data) => updateHelper({
        name,
        updateOptions: data || updateOptions
    })
    console.log({ updateOptions });

    useEffect(() => {
        dispatch(putChanged({
            type: "OBJECT_NET",
            stateKey,
            fields: [
                "lip",
                "dns",
                "gateway"
            ]
        }))
    }, [useDhcp])

    useEffect(() => {
        dispatch(putChanged({
            type: "OBJECT_NET",
            stateKey,
            fields: [
                "pppoename",
                "pppoepass"
            ]
        }))
    }, [usePppoe])



    const saveSettings = data => {

        if (!usePppoe)
            dispatch(
                settings_updateOptions({
                    type: "OBJECT_NET",
                    stateKey,
                    noChanged: true,
                    settings: {
                        "pppoename": "",
                        "pppoepass": ""
                    }
                })
            )


        if (useDhcp)
            dispatch(
                settings_updateOptions({
                    type: "OBJECT_NET",
                    stateKey,
                    noChanged: true,
                    settings: {
                        "lip": '',
                        "dns": '',
                        "gateway": ""
                    }
                })
            )
        saveSettingsInner(data)
    }


    return (
        <div>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 16,
                marginBottom: 32
            }}>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <CheckBox
                        title="Использовать PPPoE"
                        value={usePppoe}
                        onValueChanged={setUsePppoe}
                    />
                </div>
            </div>
            {usePppoe && <Builder
                className={className}
                groups={{
                    all: [
                        // Поля PPPoE (только если включен PPPoE)
                        {
                            data: {
                                className: setsex(["col-2-nowrap"]) + setsmob(["col-1"])
                            },
                            items: [
                                {
                                    title: <>{"Имя пользователя"}<br />{"для PPPoE"}</>,
                                    components: fieldPppoename({
                                        settings,
                                        name: "pppoename",
                                        onChange: hChange("pppoename")
                                    })
                                },
                                {
                                    title: <>{"Пароль пользователя"}<br />{"для PPPoE"}</>,
                                    components: fieldPppoepass({
                                        settings,
                                        name: "pppoepass",
                                        onChange: hChange("pppoepass")
                                    })
                                },
                            ]
                        }].filter(Boolean),
                }}
            />}
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
                <Switch
                    label="Способ адресации в локальной сети"
                    value={useDhcp ? "dhcp" : "static"}
                    fields={{
                        default: useDhcp ? "dhcp" : "static",
                        first:
                        {
                            title: "DHCP",
                            value: "dhcp",
                        },
                        second: {
                            title: "Статический IP",
                            value: "static",
                        }
                    }}
                    onChange={data => setUseDhcp(data.value === "dhcp")}
                    name="addressingMode"
                />
            </div>
            {<Builder
                className={className}
                groups={{
                    all: [

                        // Поля статического IP (только если PPPoE выключен и выбран Static)
                        !useDhcp && {
                            data: {
                                columns: 1,
                                noDivider: true,
                                className: setsex(["col-2", "mr", "divider-pb", "divider-bb"])
                            },
                            items: [
                                {
                                    title: "IP адрес/маска",
                                    components: fieldLip({
                                        settings,
                                        name: "lip",
                                        onChange: hChange("lip")
                                    })
                                },
                            ]
                        },

                        !useDhcp && {
                            data: {
                                columns: 1,
                                noDivider: true,
                                className: setsex(["col-4", "mr", "divider-pb"])
                            },
                            items: [
                                {
                                    title: "IP адрес шлюза",
                                    components: fieldGateway({
                                        settings,
                                        name: "gateway",
                                        onChange: hChange("gateway")
                                    })
                                },
                            ]
                        },

                        !useDhcp && {
                            data: {
                                columns: 1,
                                className: setsex(["col-4", "no-divider", "divider-pb"])
                            },
                            items: [
                                {
                                    title: "Адрес сервера DNS",
                                    components: fieldDns({
                                        settings,
                                        name: "dns",
                                        onChange: hChange("dns")
                                    })
                                },
                            ]
                        },

                        // Общие поля (для всех режимов)
                        {
                            data: {
                                className: setsex(["col-1"]),
                                noDivider: true,
                            },
                            items: [
                                {
                                    title: "Интервал синхронизации (минут)",
                                    className: "SettingsObjectNet__syncInterval",
                                    components: fieldLinterval({
                                        settings,
                                        name: "linterval",
                                        onChange: hChange("linterval")
                                    })
                                },
                            ]
                        },

                        // Кнопка сохранения
                        {
                            data: {
                                className: setsex(["col-2-nowrap"])
                            },
                            items: [
                                <ItemSave
                                    settings={settings}
                                    stateKey={stateKey}
                                    fields={fields}
                                    saveSettings={saveSettings}
                                />
                            ]
                        }
                    ].filter(Boolean),
                }}
            />}
        </div>
    )
}

export default SettingsObjectNet